import './car-single-form.scss';
import { createApp } from './form/main.js';

document.addEventListener( 'DOMContentLoaded', function() {
	const formContainer = document.getElementById( 'car-form-app' );
	
	if ( formContainer ) {
		createApp( formContainer );
	}
} );

